import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import SelectDropdown from "../../components-react/SelectDropdown";
import { fetchGymData } from "../../../data/APIs";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchInHouseUsersData } from "../../../redux/reducers/dropdownApiSlice";

const LeadGlobalFilter = (props) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);

  const { inhouseUsers } = useSelector((state) => state.dropdown);

  const { userInfoData, filters, setFilters, onClickReset } = props || {};

  const isAdmin =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "marketing";
  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  useEffect(() => {
    if (isAdmin || isManagerRole) {
      dispatch(fetchGymData(userInfoData?.token));
    }
  }, []);

  useEffect(() => {
    dispatch(
      fetchInHouseUsersData({
        token: userInfoData?.token,
        qps: filters?.selectedGym?.value
          ? `gym_id=${filters?.selectedGym?.value}`
          : "",
        pageNo: 1,
        limit: 100,
      })
    );
  }, [filters?.selectedGym]);

  return (
    <div className={`cmnFilterStructureContainer grid-2 mt15`}>
      {/* cmnFilter-abs-top-0  */}
      <div className={`filterblock gridSpanTwo`}>
        <div className="filterHeadingNBtn">
          <h5 className="filterHeading">All Filters</h5>

          <div className="filterHeadingBtnBlock lastOne">
            <div className="checkbox-btns">
              <Form.Check
                type="switch"
                name="isToggledValue"
                label={
                  filters.isToggledValue
                    ? "Switch To LMS"
                    : "Switch To LMS Beta"
                }
                checked={filters.isToggledValue}
                onChange={(event) =>
                  setFilters({
                    ...filters,
                    isToggledValue: event.target.checked,
                  })
                }
              />
            </div>

            <Button variant="outline-danger" onClick={onClickReset}>
              Reset Filter
            </Button>
          </div>
        </div>

        <div className={`filtersDropdown grid-4`}>
          {isAdmin || isManagerRole ? (
            <>
              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selectedGym?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdown
                  options={gymData?.length > 0 ? gymData : []}
                  selectedOption={filters?.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selectedGym: selectedValue,
                    })
                  }
                  name="Gym"
                  isDisable={false}
                />
              </div>

              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selAddedby?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdown
                  options={
                    inhouseUsers?.length > 0
                      ? inhouseUsers?.filter(
                          (value) => !value?.label?.includes("trainer")
                        )
                      : []
                  }
                  selectedOption={filters?.selAddedby}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selAddedby: selectedValue,
                    })
                  }
                  name="Added By"
                />
              </div>

              <div
                className={`commonWrapper dropdownCommonWrapper ${
                  filters?.selAssignee?.value && "redBorderRedText"
                }`}
              >
                <SelectDropdown
                  options={
                    inhouseUsers?.length > 0
                      ? inhouseUsers?.filter(
                          (value) => !value?.label?.includes("trainer")
                        )
                      : []
                  }
                  selectedOption={filters?.selAssignee}
                  setSelectedOption={(selectedValue) =>
                    setFilters({
                      ...filters,
                      selAssignee: selectedValue,
                    })
                  }
                  name="Assign To"
                />
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LeadGlobalFilter;
